export default "__VITE_ASSET__BlYqWkqE__"